module.exports = __webpack_public_path__ + "img/http-spa.8ddf40dd.svg";